// extracted by mini-css-extract-plugin
module.exports = {"headingWrap":"style_headingWrap__14X9K","heading":"style_heading__389sW","bounce":"style_bounce__3wa16"};